module.exports = __webpack_public_path__ + "static/media/1001016MF.a6de227c.jpg";